import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
// import { SET_FNA_VALUE } from '../actions'
import { getToggles } from '../../feature-toggles'
import { getIdentityUser } from 'identity/selectors'
import { setNotificationMessage } from 'quick-quote/notification/actions'

import VALUES from '../../../core/data-model/constants/values'

// import { SELECTED_PRODUCT } from '../../product-selection/actions'
// import { SET_FNA_NEED_CATEGORY } from '../need-and-gap-analysis/actions'

import {
  UPDATE_SUITABILITY_ANSWER,
  clearSuitabilityAnswers,
  updateSuitabilityStatus,
  updateSuitabilityScore,
} from './actions'
import { getSuitabilityAnswers } from './selectors'
import { submitSuitabilityAnswer } from 'core/service-wrapper/partner-api/service'

export function* clearSuitabilityAnswersAndNoticeMessage() {
  yield put(clearSuitabilityAnswers())
  yield put(updateSuitabilityStatus(false))
  yield put(
    setNotificationMessage({
      type: 'ConfirmModal',
      title: 'คำเตือน',
      message:
        'ท่านไม่ผ่านเกณฑ์การประเมินความเข้าใจเบื้องต้น ผลิตภัณฑ์นี้อาจมีความเสี่ยงไม่เหมาะสมกับความต้องการของท่าน',
    })
  )
}

export function* onSuitabilityAnswerChange() {
  const suitabilityAnswers = yield select(getSuitabilityAnswers)
  const isArray = Array.isArray(suitabilityAnswers)
  const hasThreeAnswers = isArray && suitabilityAnswers.length === 3

  if (hasThreeAnswers) {
    const payload = {
      data: {
        suitabilityAnswers: suitabilityAnswers.map((a) => ({
          questionCode: a.questionCode,
          answerMode: a.answerMode || 'NORMAL',
          answerChoice: a.answerChoice,
          answerOptionals: a.optionalCode || null,
        })),
      },
    }

    const user = yield select(getIdentityUser)
    let retrieveSuitabilityScore
    try {
      retrieveSuitabilityScore = yield call(submitSuitabilityAnswer, user, payload)
    } catch (error) {
      yield put(
        setNotificationMessage({
          type: 'ConfirmModal',
          title: 'เกิดข้อผิดพลาด',
          message: `ไม่สามารถเรียก API submitSuitabilityAnswer ได้ กรุณาลองใหม่อีกครั้ง (${error?.message ||
            'Unknown error'})`,
        })
      )
      return
    }

    if (retrieveSuitabilityScore) {
      if (retrieveSuitabilityScore.suitabilitytestRiskFlag === 'Y') {
        yield put(updateSuitabilityStatus(true))
        yield put(updateSuitabilityScore(retrieveSuitabilityScore))
      } else {
        yield call(clearSuitabilityAnswersAndNoticeMessage)
      }
    }
  }
}

export function* watchers() {
  yield [takeLatest(UPDATE_SUITABILITY_ANSWER, onSuitabilityAnswerChange)]
}

export const sagas = watchers
